<template>
  <CRow>
    <CCol md="12" class="actions-col">
      <div class="mb-2">
        <div role="group" class="form-group">
          <CButton v-if="showButton('new-guest')" color="danger" size="sm" @click="$emit('new-guest')">
            Nuevo Invitado
          </CButton>

          <CDropdown v-if="showCommunicationsDropdown" color="info" size="sm" class="action-dropdown">
            <template #toggler-content>
              Envios
            </template>

            <CDropdownItem v-if="showButton('schedule-sends')" href="#" @click="$emit('schedule-sends')">
              Programar envio
            </CDropdownItem>

            <CDropdownDivider v-if="showButton('schedule-sends') && showCommunicationItemsDivider" />

            <CDropdownItem v-if="showButton('send-message')" href="#" @click="$emit('send-message')">
              Enviar Mensaje
            </CDropdownItem>

            <CDropdownItem v-if="showButton('send-remember')" href="#" @click="$emit('send-remember')">
              Enviar Recordatorios
            </CDropdownItem>
            
            <CDropdownItem v-if="showButton('send-invitation')" href="#" @click="$emit('send-invitation')">
              Enviar Invitaciones
            </CDropdownItem>

            <CDropdownItem v-if="showButton('send-save-date')" href="#" @click="$emit('send-save-date')">
              Save The Date
            </CDropdownItem>

            <CDropdownItem v-if="showButton('send-preinvitation')" href="#" @click="$emit('send-preinvitation')">
              Preinvitacion
            </CDropdownItem>

            <CDropdownItem v-if="showButton('send-event-reminder')" href="#" @click="$emit('send-event-reminder')">
              Recordatorio de Evento
            </CDropdownItem>

            <CDropdownItem v-if="showButton('send-tables')" href="#" @click="$emit('send-tables')">
              Enviar Mesa
            </CDropdownItem>

            <CDropdownItem v-if="showButton('send-masive-tickets-email')" href="#" @click="$emit('send-masive-tickets-email')">
              Enviar Tickets
            </CDropdownItem>
          </CDropdown>

          <CDropdown v-if="showImportExportDropdown" color="success" size="sm" class="action-dropdown">
            <template #toggler-content>
              Importar / Exportar
            </template>

            <CDropdownItem v-if="showButton('import-guests')" href="#" @click="$emit('import-guests')">
              Importar Invitados
            </CDropdownItem>

            <CDropdownItem v-if="showButton('import-history')" href="#" @click="$emit('import-history')">
              Historial de importaciones
            </CDropdownItem>

            <CDropdownItem v-if="showButton('export-guests')" href="#" @click="$emit('export-guests')">
              Exportar Listado Excel
            </CDropdownItem>

            <CDropdownItem v-if="showButton('send-excel-email')" href="#" @click="$emit('send-excel-email')">
              Enviar Excel por correo
            </CDropdownItem>

            <CDropdownDivider v-if="showButton('export-attendance') || showButton('scanQR')" />

            <CDropdownItem v-if="showButton('export-attendance')" href="#" @click="$emit('export-attendance')">
              Exportar Asistencia
            </CDropdownItem>

            <CDropdownItem v-if="showButton('scanQR')" :to="{ name: 'scan-tickets', params: { id: event.id } }">
              Escanear CODIGOS
            </CDropdownItem>
          </CDropdown>

          <CButton v-if="showButton('assign-table')" class="crema" size="sm" @click="$emit('assign-table')">
            Asignar Mesa
          </CButton>
        </div>
      </div>
    </CCol>
  </CRow>
</template>

<script>
export default {
  name: 'GuestsActions',
  props: {
    event: { type: Object, required: true },
    items: { type: Array, required: true },
    hasTables: { type: Number, default: 0 }
  },
  computed: {
    showCommunicationsDropdown() {
      return this.showButton('schedule-sends') ||
        this.showButton('send-message') ||
        this.showButton('send-remember') ||
          this.showButton('send-invitation') ||
        this.showButton('send-save-date') ||
        this.showButton('send-preinvitation') ||
        this.showButton('send-event-reminder') ||
        this.showButton('send-tables') ||
        this.showButton('send-masive-tickets-email');
    },
    showCommunicationItemsDivider() {
      return this.showButton('send-message') ||
        this.showButton('send-remember') ||
          this.showButton('send-invitation') ||
        this.showButton('send-save-date') ||
        this.showButton('send-preinvitation') ||
        this.showButton('send-event-reminder') ||
        this.showButton('send-tables') ||
        this.showButton('send-masive-tickets-email');
    },
    showImportExportDropdown() {
      return this.showButton('import-guests') ||
        this.showButton('import-history') ||
        this.showButton('export-guests') ||
        this.showButton('send-excel-email') ||
        this.showButton('export-attendance') ||
        this.showButton('scanQR');
    }
  },
  methods: {
    showButton(type = "save", item = null) {

      if (!this.event || !this.event.status) return false

      switch (type) {

        case "scanQR":
        case "export-attendance":
          return this.event.status.code === "open" &&
            this.event.external_registration_enabled

        case "new-guest":
        case "import-guests":
        case "import-history":
          return this.event.status.code === "open"

        case "schedule-sends":
          return this.event.status.code === "open" && this.items.length > 0

        case "assign-table":
        case "send-tables":
          return this.event.status.code === "open" &&
            this.hasTables > 0 &&
            this.items.length > 0

        case "export-guests":
        case "send-excel-email":
          return this.items.length > 0

        case "send-invitation":
        case "send-remember":
        case "send-save-date":
        case "send-preinvitation":
        case "send-event-reminder":
        case "send-message":
          return this.event.status.code === "open" &&
            this.event.contact_method !== "email"

        case "send-masive-tickets-email":
          return this.event.status.code === "open" &&
            this.event.contact_method === "email" &&
            this.items.length > 0

        default:
          return false
      }
    }
  }
}
</script>
<style scoped>
.actions-col {
  display: flex;
  justify-content: flex-end;
}
.form-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px ;
}

.action-dropdown {
  display: inline-flex;
}

.action-dropdown ::v-deep .btn {
  color: #fff;
}

@media (max-width: 767px) {
  .form-group {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .form-group .btn,
  .action-dropdown,
  .action-dropdown ::v-deep .btn {
    width: 100%;
  }
}
</style>
